<template>
  <div id="expensesJurManagement" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">费用归属部门：</div>
          <div class="content">
            <el-select
              v-model="form.expeDeptCode"
              @visible-change="getExpensesDeptList"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in expensesDeptList"
                :key="item.expeDeptCode"
                :label="item.expeDeptName"
                :value="item.expeDeptCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">费用类型：</div>
          <div class="content">
            <el-select
              v-model="form.expeTypeCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in expensesTypeList"
                :key="item.expenseTypeCode"
                :label="item.expenseTypeName"
                :value="item.expenseTypeCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">申请部门：</div>
          <div class="content">
            <el-select v-model="form.deptCode" @visible-change="getApplyDeptList" clearable filterable placeholder="请选择">
              <el-option
                v-for="item in applyDeptList"
                :key="item.deptCode"
                :label="item.deptName"
                :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addHandlen">添加</el-button>
    </div>
    <commonTable ref="expensesJurManagementTable" />
    <addExpenseJurDialog
      @expenseJurSubHandle="expenseJurSubHandle"
      @dialogCloseHandle="expenseJurDialogVisible = false"
      :expense-jur-dialog-visible="expenseJurDialogVisible"
      :expenses-type-list="expensesTypeList"
    />
  </div>
</template>
<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { expensesJurManagementApi, budgetPerformanceApi } from './service';
import addExpenseJurDialog from './component/expensesJurManagement/addExpenseJurDialog';

export default {
  data () {
    return {
      form: {},
      tableData: [],
      expensesDeptList: [],
      expensesTypeList: [],
      applyDeptList: [],
      expenseJurDialogVisible: false
    };
  },
  components: {
    commonTable,
    addExpenseJurDialog
  },
  computed: {},
  methods: {
    deleteHandle (row) {
      this.$confirm('确定删除此申请权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        expensesJurManagementApi.delExpenseJur(row.id).then(res => {
          if (res.status === '200') {
            this.searchBtn();
            this.$message.success('删除成功');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    expenseJurSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      expensesJurManagementApi.addExpenseJur(data).then(res => {
        if (res.status === '200') {
          this.loadTable();
          this.expenseJurDialogVisible = false;
          this.$message.success('提交成功');
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addHandlen () {
      this.expenseJurDialogVisible = true;
    },
    reset () {
      this.form = {};
      this.searchBtn();
    },
    searchBtn () {
      this.$refs.expensesJurManagementTable.pageData.pageNum = 1;
      this.$refs.expensesJurManagementTable.loadTable({
        url: '/expense_config/expense_config_list',
        listKey: 'list',
        params: this.form
      });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('申请部门编号')
          ._width('120')
          ._data('deptCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('申请部门名称')
          ._width('120')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门编号')
          ._width('140')
          ._data('expeDeptCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门名称')
          ._width('220')
          ._data('expeDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用类型')
          ._width('120')
          ._data('expeTypeName')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新时间')
          ._width('120')
          ._data('updateTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = row[column.property] ? new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd') : '';
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('140')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.expensesJurManagementTable.setColumn(column);
      this.$refs.expensesJurManagementTable.loadTable({
        url: '/expense_config/expense_config_list',
        listKey: 'list',
        params: this.form
      });
    },
    getExpensesDeptList (flag) {
      if (flag) {
        expensesJurManagementApi.getExpenseDeptList().then(res => {
          if (res.status === '200') {
            this.expensesDeptList = res.data;
          }
        });
      }
    },
    getApplyDeptList (flag) {
      if (flag) {
        expensesJurManagementApi.getApplyDeptList().then(res => {
          if (res.status === '200') {
            this.applyDeptList = res.data;
          }
        });
      }
    },
    getExpenseTypeList () {
      budgetPerformanceApi.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expensesTypeList = res.data;
        }
      });
    }
  },
  mounted () {
    this.loadTable();
    this.getExpenseTypeList();
  }
};
</script>
<style lang="scss" scoped>

</style>
